import React, { Fragment, Component } from 'react';
import constants from '../../constants';
import { translate } from '../../Services/translation';

class CookieBar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cookiebarVisible: props.cookiebarVisible,
            showButton: props.showButton,
            settingsVisible: false,
            functional: props.functional === 'true',
            analytics: props.analytics === 'true',
            marketing: props.marketing === 'true',
            functionalStatusText: translate('common.cookie.' + (props.functional === 'true' ? "active" : "disabled")),
            analyticsStatusText: translate('common.cookie.' + (props.analytics === 'true' ? "active" : "disabled")),
            marketingStatusText: translate('common.cookie.' + (props.marketing === 'true' ? "active" : "disabled")),
        };
    }

    showSettings() {
        this.setState(() => ({ settingsVisible: true }));
    }
    acceptAllCookies(delayClose) {

        this.setState(() => ({ functional: true, analytics: true, marketing: true, settingsVisible: delayClose, cookiebarVisible: false }));
        var now = new Date();
        now.setTime(now.getTime() + 3600 * 1000 * 24 * 365);
        var cookieExpires = now.toUTCString();
        document.cookie = "cookie_consent=functional,analytics,marketing;expires=" + cookieExpires + ";path=/";

        gtag('consent', 'update', {
            'ad_storage': 'granted',
            'ad_personalization': 'granted',
            'ad_user_data': 'granted',
            'analytics_storage': 'granted',
            'functionality_storage': 'granted',
            'personalization_storage': 'granted',
        });
    }
    acceptCookiesWithDelay() {
        this.acceptAllCookies(true);
        setTimeout(() => {
            this.setState(() => ({ settingsVisible: false, cookiebarVisible: false }));
        }, 1000);
    }
    acceptCookies() {
        this.setState(() => ({ settingsVisible: false, cookiebarVisible: false }));

        var now = new Date();
        now.setTime(now.getTime() + 3600 * 1000 * 24 * 365);
        var cookieExpires = now.toUTCString();

        document.cookie = "cookie_consent=" +
            (this.state.functional ? "functional," : "") +
            (this.state.analytics ? "analytics," : "") +
            (this.state.marketing ? "marketing," : "") +
            ";expires=" + cookieExpires + ";path=/";

        gtag('consent', 'update', {
            'ad_storage': (this.state.marketing ? 'granted' : 'denied'),
            'ad_user_data': (this.state.marketing ? 'granted' : 'denied'),
            'ad_personalization': (this.state.marketing ? 'granted' : 'denied'),
            'analytics_storage': (this.state.analytics ? 'granted' : 'denied'),
            'functionality_storage': (this.state.functional ? 'granted' : 'denied'),
            'personalization_storage': (this.state.marketing ? 'granted' : 'denied')
        });

    }
    acceptNecessaryCookies() {
        this.setState(() => ({ analytics: false }));
        this.setState(() => ({ functional: false }));
        this.setState(() => ({ marketing: false }));

        this.acceptCookies();        
    }
    setAnalytics() {
        this.setState(() => ({ analytics: !this.state.analytics }));
        this.setState(() => ({ analyticsStatusText: this.state.analytics ? translate('common.cookie.disabled') : translate('common.cookie.active') }));
    }
    setFunctional() {
        this.setState(() => ({ functional: !this.state.functional }));
        this.setState(() => ({ functionalStatusText: this.state.functional ? translate('common.cookie.disabled') : translate('common.cookie.active') }));
    }
    setMarketing() {
        this.setState(() => ({ marketing: !this.state.marketing }));
        this.setState(() => ({ marketingStatusText: this.state.marketing ? translate('common.cookie.disabled') : translate('common.cookie.active') }));
    }

    render() {
        let functionalStatusText = this.state.functionalStatusText;
        let analyticsStatusText = this.state.analyticsStatusText;
        let marketingStatusText = this.state.marketingStatusText;
        return (
            <Fragment>
                {this.state.showButton &&
                    <button className="cookie-accept-settings-btn all" onClick={() => this.showSettings()} aria-label={translate(`common.cookie.change`)}>{translate(`common.cookie.change`)}</button>
                }
                {this.state.cookiebarVisible &&
                    <div className="cookie-bar">
                        <div className="cookie-bar-container row">
                            <div className="cookie-bar-content"><p>{translate(`common.cookie.information1`)}<a className="cookie-bar-policy-link" href={constants.cookieTermsPageUrl}>{translate(`common.cookie.text`)}</a>{translate(`common.cookie.information2`)}<a className="cookie-bar-policy-link" href={constants.policyTermsPageUrl}>{translate(`common.cookie.privacy.policy`)}</a>.</p></div>
                            <div className="cookie-bar-button-container">
                                <button className="cookie-accept-btn" onClick={() => this.acceptAllCookies(false)} aria-label={translate(`common.cookie.accept`)}>{translate(`common.cookie.accept`)}</button>
                                <button className="cookie-accept-btn" onClick={() => this.acceptNecessaryCookies()} aria-label={translate(`common.cookie.acceptnecessary`)}>{translate(`common.cookie.acceptnecessary`)}</button>
                                <button className="cookie-settings-btn" onClick={() => this.showSettings()} aria-label={translate(`common.cookie.settings`)}>{translate(`common.cookie.settings`)}</button>
                            </div>
                        </div>
                    </div>
                }
                {this.state.settingsVisible &&
                    <div className="cookie-bar-settings__wrapper" ref="wrapper">
                        <div className="cookie-bar-settings row">
                            <div className="small-12 column">
                                <div className="cookie-bar-settings__header">
                                    <h2 className="text--center">{translate(`common.cookie.header`)}</h2>
                                </div>
                                <div className="cookie-bar-settings__info">{translate(`common.cookie.settings.info`)} <a href={constants.cookieTermsPageUrl}>{translate(`common.cookie.settings.readmore`)}</a></div>
                                <div className="cookie-bar-settings__setting">
                                    <div>{translate(`common.cookie.necessary`)}</div>
                                    <div>{translate(`common.cookie.alwaysactive`)}</div>
                                </div>
                                <div className="cookie-bar-settings__setting">
                                    <div>{translate(`common.cookie.functional`)}</div>
                                    <div>
                                        <span className="cookie-bar-settings__status">{functionalStatusText}</span>
                                        <label className="cookie-bar-settings__switch">
                                            <input type="checkbox" checked={this.state.functional} name="functional" onChange={() => this.setFunctional()} />
                                            <span className="slider round"></span>
                                        </label>
                                    </div>
                                </div>
                                <div className="cookie-bar-settings__setting">
                                    <div>{translate(`common.cookie.analysis`)}</div>
                                    <div>
                                        <span className="cookie-bar-settings__status">{analyticsStatusText}</span>
                                        <label className="cookie-bar-settings__switch">
                                            <input type="checkbox" checked={this.state.analytics} name="analytics" onChange={() => this.setAnalytics()} />
                                            <span className="slider round"></span>
                                        </label>
                                    </div>
                                </div>
                                <div className="cookie-bar-settings__setting">
                                    <div>{translate(`common.cookie.marketing`)}</div>
                                    <div>
                                        <span className="cookie-bar-settings__status">{marketingStatusText}</span>
                                        <label className="cookie-bar-settings__switch">
                                            <input type="checkbox" checked={this.state.marketing} name="marketing" onChange={() => this.setMarketing()} />
                                            <span className="slider round"></span>
                                        </label>
                                    </div>
                                </div>
                                <div className="cookie-bar-settings__setting">
                                    <button className="cookie-accept-settings-btn" onClick={() => this.acceptCookies()}>{translate(`common.cookie.settings.acceptchoices`)}</button>
                                    <button className="cookie-accept-settings-btn all" onClick={() => this.acceptCookiesWithDelay()}>{translate(`common.cookie.settings.acceptall`)}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </Fragment>
        )
    }
}
export default CookieBar;